package com.vizio.redwolf.utils.clientprovider

import com.vizio.redwolf.utils.ClientConfig
import com.vizio.redwolf.utils.DEFAULT_RETRY_CONFIG
import com.vizio.redwolf.utils.DEFAULT_TIMEOUT
import com.vizio.redwolf.utils.Platform
import com.vizio.redwolf.utils.RetryConfig
import com.vizio.redwolf.utils.platform

object ClientConfigFactory {
    fun getClientConfig(
        webApiUseCase: WebApiUseCase,
        timeout: Long = DEFAULT_TIMEOUT,
        retryConfig: RetryConfig = DEFAULT_RETRY_CONFIG
    ): ClientConfig {
        val clientProvider = when (platform) {
            Platform.JS -> {
                when (webApiUseCase) {
                    WebApiUseCase.COOKIE_SDK_HEADERS -> CookieClientProvider
                    WebApiUseCase.SDK_HEADERS -> DefaultClientProvider
                    WebApiUseCase.BASIC -> BasicClientProvider
                }
            }
            Platform.Android,
            Platform.iOS -> DefaultClientProvider
        }
        return ClientConfig(clientProvider, timeout, retryConfig)
    }
}